import Spinner from "components/General-UI/Spinner";
import React from "react";
import { useSelector } from "react-redux";
import { selectSocketDrops } from "slices/generalSlice";
import { selectNetworkConnection } from "slices/mediaServerSlice";
import Modal from "../../HOCS/Modal";

const ConnectionError = () => {
  const connectionOut = useSelector(
    (state) => selectSocketDrops(state) >= 9 || !selectNetworkConnection(state)
  );

  if (connectionOut) {
    return (
      <Modal
        growth={false}
        noBackDropClick={true}
        lightBackDrop={false}
        header={"Trouble connecting to the Server"}
        content={
          <>
            <br />
            <Spinner
              message={"Attempting to reconnect..."}
              immediateShow={true}
            />
            <br />
            You're internet connection may be down or we may be fixing an issue.
            Try restarting your browser if the issue persists.
          </>
        }
        onDismiss={() => {
          window.efs_debug && window.log("Tried to dismiss lol");
        }}
        persist={true}
      />
    );
  } else {
    return null;
  }
};

export default ConnectionError;
